export const BE_POSTCODE_ERROR_MESSAGE =
  'Received an error message in the API response: We are currently unable to offer insurance for customers in this area, please review the address entered or alternatively contact our customer service team';
export const CLIENT_POSTCODE_ERROR_MESSAGE = '[customer] invalid postCode format';
export const NOT_MICROCHIPPED_ERROR_MESSAGE = 'pet_not_microchipped';
export const OWNER_UNDER_EIGHTEEN_ERROR_MESSAGE = 'owner_under_eighteen';
export const QUOTE_NOT_FOUND = 'quote_not_found';
export const FORM_VALIDATION = 'form_validation';
export const TOO_MANY_REQUESTS_ERROR_MESSAGE = 'TOO_MANY_REQUESTS_ERROR_MESSAGE';
